import React from 'react';

export default function Help() {

    return (
        <div className="view-container">
            <div className="question-section">
                <span className="primary-question">Frequently Asked Questions</span>
                <p></p>
                <span className="primary-question">Q. Can I still call to report any odour concerns?</span>
                <span className="question-helper">
                    Yes. You can continue to also call us on <a href="tel:0800765588">0800 765 588</a> (24 hours), to report any odour concerns.
                </span>
                <p></p>
                <span className="primary-question">Q. How can I get the latest updates for the app?</span>
                <span className="question-helper">
                    If you are using the app in your browser, then please close all the open tabs for this app and reopen the app using the address <a href="https://smelt-it.web.app">https://smelt-it.web.app</a>.
                    If you have saved the app on your phone, then please close and reopen the app.
                </span>
                <p></p>
                <span className="primary-question">Q. I see a "A new version of this app is available. Click here to update." message, can I continue with the submission anyways?</span>
                <span className="question-helper">
                    This message means that we have made some changes to the app and we strongly recommend that you update the app to ensure that your report is successfully submitted.
                </span>
                <p></p>
                <span className="primary-question">Q. Do you collect any personal information through the app?</span>
                <span className="question-helper">
                    We do not collect any personal information about you through the app, unless you choose to share your name, email or phone number through the app. Your privacy is important to us and any information we collect through this app will be shared with Environment Canterbury staff only, for the purpose of this project.
                </span>
                <p></p>
                <span className="primary-question">Q. I wish to recieve updates on this project, what can I do?</span>
                <span className="question-helper">
                    You can choose to provide your email address through the app and we will add you to our email list for updates.
                </span>
                <p></p>
                <span className="primary-question">Q. I am happy to provide more information regarding my Smelt-it report, what can I do?</span>
                <span className="question-helper">
                    You can use the 'Optional comment' section in the app to add any additional information that you may want to share with us. You can also choose to share your full name and phone number with us through the app and we will get in touch with you if we need more information.
                </span>
                <p></p>
                <span className="primary-question">Q. When I try to open the app, I get a blank page with the message 'You need to enable JavaScript to run this app.' What should I do ?</span>
                <span className="question-helper">
                    The app needs JavaScript to be enabled in your browser for it to function.You can go to your browser settings to either enable JavaScript for all sites or you can allow JavaScript for just the Smelt-it app. For specific browser instructions please visit this <a target='_blank' rel="noopener noreferrer" href="https://support.google.com/adsense/answer/12654?hl=en">link</a>
                </span>
                <p></p>
                <span className="primary-question">Q. Where can I learn more about this project?</span>
                <span className="question-helper">
                    Head to <a target='_blank' rel="noopener noreferrer" href='https://ecan.govt.nz/bromleyodour'>ecan.govt.nz/bromleyodour</a> for more details or call Customer Services on <a href="tel:0800 324 636">0800 324 636</a>.
                </span>
            </div>
        </div>
    )
}